import { initializeApp } from "firebase/app";
import { browserLocalPersistence, getAuth, setPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
import { getAnalytics, isSupported as analyticsIsSupported } from "firebase/analytics";
import { getPerformance } from "firebase/performance";

export default defineNuxtPlugin({
  name: "firebase",
  async setup(nuxtApp) {
    const { public: config } = useRuntimeConfig();

    const firebaseConfig = {
      apiKey: config.firebaseApiKey,
      authDomain: config.authDomain,
      databaseURL: config.databaseURL,
      projectId: config.projectId,
      storageBucket: config.storageBucket,
      messagingSenderId: config.messagingSenderId,
      appId: config.appId,
      measurementId: config.measurementId,
    };

    const app = initializeApp(firebaseConfig);
    const auth = getAuth(app);

    // Keep the Firebase session across refreshes so route guards can restore state.
    try {
      await setPersistence(auth, browserLocalPersistence);
    } catch (error) {
      console.warn("Failed to enable Firebase local auth persistence.", error);
    }

    const firestore = getFirestore(app);

    nuxtApp.vueApp.provide("auth", auth);
    nuxtApp.provide("auth", auth);

    nuxtApp.vueApp.provide("firestore", firestore);
    nuxtApp.provide("firestore", firestore);

    const rtdb = getDatabase(app);
    nuxtApp.vueApp.provide("rtdb", rtdb);
    nuxtApp.provide("rtdb", rtdb);

    // Firebase Analytics – only supported in environments with IndexedDB/cookies.
    const analyticsSupported = await analyticsIsSupported();
    if (analyticsSupported) {
      const analytics = getAnalytics(app);
      nuxtApp.vueApp.provide("analytics", analytics);
      nuxtApp.provide("analytics", analytics);
    }

    // Firebase Performance – initialize defensively; no isSupported export in SDK.
    try {
      const perf = getPerformance(app);
      nuxtApp.vueApp.provide("performance", perf);
      nuxtApp.provide("performance", perf);
    } catch (error) {
      console.warn("Firebase Performance monitoring is not available.", error);
    }
  },
});
